import React, { FC } from 'react'
type Props = {
    actions: React.ReactNode
}
export const ActionCell: FC<Props> = ({ actions }) => {
  return (
    <td>{actions}</td>
  )
}
